import DownloadQRCode from './index.vue';

DownloadQRCode.install = (Vue) => {
  Vue.component(DownloadQRCode.name, DownloadQRCode);
};

export default DownloadQRCode;
